<script setup lang="ts">
import { computed } from 'vue';
import type { TaxIdStatusDescription } from '@/types/enums';
import { getPersonTaxIdStatusPresentation } from '@/utils/personTaxIdStatusPresentation';
import BaseIcon from '@/components/base/BaseIcon.vue';

const props = defineProps<{
  status: TaxIdStatusDescription | undefined;
}>();

const presentation = computed(() => getPersonTaxIdStatusPresentation(props.status));
</script>

<template>
  <span class="inline-flex items-center gap-1 align-middle" :class="presentation.className">
    {{ status }}
    <BaseIcon v-if="presentation.icon" size="xs">{{ presentation.icon }}</BaseIcon>
  </span>
</template>
